import { FC } from 'react';
import styled from 'styled-components';

type ErrorProps = {
  message: string;
};

const ErrorDiv = styled.div`
  color: red;
  padding-bottom: 15px;
`;

const ErrorComponent: FC<ErrorProps> = props => <ErrorDiv>{props.message}</ErrorDiv>;

export default ErrorComponent;
